import WithdrawTransactions from "@/pages/components/WithdrawTransactionList";
import {Box, Card} from "@mui/material";
// @ts-ignore
import useMobileDetect from "next-device-detection";
import classes from './TransList.module.css'
import mobileClasses from './mobile.module.css'
import {getUrlParams} from "@/utils/utils.js";

function AssetsTransList() {
  const detectMobile = useMobileDetect();
  return (
    <>
      {
        // detectMobile.isMobile &&
        <Box
          className={mobileClasses.root}>
          <WithdrawTransactions bussinessType={38} isCompact={false} pageable/>
        </Box>
      }
    </>

  );
}

export default AssetsTransList;
